<template>
    <div style="display: flex; justify-content: space-between; max-height: 100vh;">

        <!-- Left Cards -->
        <div style="margin: 15px 0 0 65px">
            <div class="item-body" style="margin-bottom: 15px">
                <div class="item-text">
                    <i class="pi pi-clock font-size-icon" /> 
                    <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Dia atual') }}</div>
                </div>

                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Índice de utilização:') }}</div>
                    <div style="font-weight: bold; margin: 3px 0;">{{ displayValue(map_overlay_data && map_overlay_data.utilization, '%') }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Disponibilidade mecânica:') }}</div>
                    <div style="font-weight: bold; margin: 3px 0;">{{ displayValue(map_overlay_data && map_overlay_data.mechanical_availability, '%') }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Tempo de motor ligado:') }}</div>
                    <div style="font-weight: bold; margin: 3px 0;">{{ displayValueHour(map_overlay_data && map_overlay_data.machine_on_time, 'h') }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Consumo médio:') }}</div>
                    <div style="font-weight: bold; margin: 3px 0;">{{ displayValue(map_overlay_data && map_overlay_data.average_consumption, ' L/h') }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Consumo total:') }}</div>
                    <div style="font-weight: bold; margin: 3px 0;">{{ displayValue(map_overlay_data && map_overlay_data.total_consumption, ' L') }}</div>
                </div>
            </div>
            <div class="item-body" style="margin-bottom: 15px;">
                <div class="item-text">
                    <i class="pi pi-tags font-size-icon" /> 
                    <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Últimos resultados') }}</div>
                </div>

                <table style="border-spacing: 5px; text-align: center; font-size: 14px; width: 100%; height: 130px;">
                    <thead>
                        <tr>
                            <th></th>
                            <th style="border-left: 1px solid white;">{{ $t('AppDashboardMapOverlay.Utilização') }}</th>
                            <th style="border-left: 1px solid white;">{{ $t('AppDashboardMapOverlay.Disponibilidade') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="border-right: 1px solid white; border-top: 1px solid white;">{{ $t('AppDashboardMapOverlay.Turno A') }}</td>
                            <td style="border-right: 1px solid white; border-top: 1px solid white;">
                                {{ isValidUtilization(
                                    displayValue(map_overlay_data && map_overlay_data.shift_a && map_overlay_data.shift_a.utilization, '%'),
                                    displayValue(map_overlay_data && map_overlay_data.shift_a && map_overlay_data.shift_a.mechanical_availability, '%')
                                ) }}
                            </td>
                            <td style="border-top: 1px solid white;">
                                {{ isValidMechanicalAvailability(
                                    displayValue(map_overlay_data && map_overlay_data.shift_a && map_overlay_data.shift_a.utilization, '%'),
                                    displayValue(map_overlay_data && map_overlay_data.shift_a && map_overlay_data.shift_a.mechanical_availability, '%')
                                ) }}
                            </td>
                        </tr>
                        <tr>
                            <td style="border-right: 1px solid white; border-top: 1px solid white;">{{ $t('AppDashboardMapOverlay.Turno B') }}</td>
                            <td style="border-right: 1px solid white; border-top: 1px solid white;">
                                {{ isValidUtilization(
                                    displayValue(map_overlay_data && map_overlay_data.shift_b && map_overlay_data.shift_b.utilization, '%'),
                                    displayValue(map_overlay_data && map_overlay_data.shift_b && map_overlay_data.shift_b.mechanical_availability, '%')
                                ) }}
                            </td>
                            <td style="border-top: 1px solid white;">
                                {{ isValidMechanicalAvailability(
                                    displayValue(map_overlay_data && map_overlay_data.shift_b && map_overlay_data.shift_b.utilization, '%'),
                                    displayValue(map_overlay_data && map_overlay_data.shift_b && map_overlay_data.shift_b.mechanical_availability, '%')
                                ) }}
                            </td>
                        </tr>
                        <tr>
                            <td style="border-right: 1px solid white; border-top: 1px solid white;">{{ $t('AppDashboardMapOverlay.Turno C') }}</td>
                            <td style="border-right: 1px solid white; border-top: 1px solid white;">
                                {{ isValidUtilization(
                                    displayValue(map_overlay_data && map_overlay_data.shift_c && map_overlay_data.shift_c.utilization, '%'),
                                    displayValue(map_overlay_data && map_overlay_data.shift_c && map_overlay_data.shift_c.mechanical_availability, '%')
                                ) }}
                            </td>
                            <td style="border-top: 1px solid white;">
                                {{ isValidMechanicalAvailability(
                                    displayValue(map_overlay_data && map_overlay_data.shift_c && map_overlay_data.shift_c.utilization, '%'),
                                    displayValue(map_overlay_data && map_overlay_data.shift_c && map_overlay_data.shift_c.mechanical_availability, '%')
                                ) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-body" v-if="alerts && alerts.length > 0">
                <div style="display: flex; justify-content: space-between;">
                    <div class="item-text">
                        <i class="pi pi-exclamation-triangle font-size-icon" /> 
                        <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Alertas') }}</div>
                    </div>
                    <div class="quantity-font-size">{{ alerts.length }}</div>
                </div>

                <div class="scroll-box">
                    <div style="display: flex; flex-wrap: wrap; gap: 10px">
                        <div v-for="alert in alerts" class="item-box" 
                                style="background-color: rgba(255, 0, 0, 0.4); border: 1px solid #FF0000; flex: 0 0 calc(50% - 10px); box-sizing: border-box;">
                            <div>{{ alert.fleet }}</div>
                            <div>{{ alert.quantity }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Cards -->
        <div style="margin: 15px 45px 0 0">
            <div class="item-body" style="margin-bottom: 15px;">
                <div class="item-text">
                    <i class="pi pi-chevron-circle-right font-size-icon" /> 
                    <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Status da Frota') }}</div>
                </div>

                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Ativas:') }}</div>
                    <div style="font-weight: bold; border-radius: 3px; padding: 0 5px; margin: 3px 0; background-color: #00A63E;">{{ displayFleetValue(fleet_status && fleet_status.active) }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Desligadas:') }}</div>
                    <div style="font-weight: bold; border-radius: 3px; padding: 0 5px; margin: 3px 0; background-color: #5E3F20;">{{ displayFleetValue(fleet_status && fleet_status.stop) }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Sem comunicação:') }}</div>
                    <div style="font-weight: bold; border-radius: 3px; padding: 0 5px; margin: 3px 0; background-color: #888888;">{{ displayFleetValue(fleet_status && fleet_status.inactive) }}</div>
                </div>
                <div style="display: flex; justify-content: space-between; font-size: 14px;">
                    <div>{{ $t('AppDashboardMapOverlay.Total de máquinas:') }}</div>
                    <div style="font-weight: bold; border-radius: 3px; padding: 0 5px; margin: 3px 0; background-color: #155DFC;">{{ displayFleetValue(fleet_status && fleet_status.total) }}</div>
                </div>
            </div>
            <div class="item-body" :class="{'apply-height-item' :  !idle_machines || idle_machines.length === 0}" style="margin-bottom: 15px;">
                <div style="display: flex; justify-content: space-between;">
                    <div class="item-text">
                        <i class="pi pi-power-off font-size-icon" /> 
                        <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Máquinas ociosas') }}</div>
                    </div>
                    <div class="quantity-font-size">{{ displayFleetValue(idle_machines && idle_machines.length) }}</div>
                </div>

                <div class="scroll-box">
                    <div style="display: flex; flex-wrap: wrap; gap: 10px">
                        <div v-for="item in idle_machines" class="item-box" 
                                style="background-color: rgba(255, 0, 0, 0.4); border: 1px solid #FF0000; flex: 0 0 calc(50% - 10px); box-sizing: border-box;">
                            <div>{{ item.fleet }}</div>
                            <div>{{ item.time }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-body" :class="{'apply-height-item' :  !fuel_level || fuel_level.length === 0}" style="margin-bottom: 15px;">
                <div style="display: flex; justify-content: space-between;">
                    <div class="item-text">
                        <i class="pi pi-car font-size-icon" /> 
                        <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Nível do tanque') }}</div>
                    </div>
                    <div class="quantity-font-size">{{ displayFleetValue(fuel_level && fuel_level.length) }}</div>
                </div>

                <div class="scroll-box">
                    <div style="display: flex; flex-wrap: wrap; gap: 10px">
                        <div v-for="item in fuel_level" class="item-box" 
                                style="background-color: rgba(255, 255, 0, 0.4); border: 1px solid #FFFF00; flex: 0 0 calc(50% - 10px); box-sizing: border-box;">
                            <div>{{ item.fleet }}</div>
                            <div>{{ item.level }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-body" :class="{'apply-height-item' :  !maintenance_machines || maintenance_machines.length === 0}">
                <div style="display: flex; justify-content: space-between;">
                    <div class="item-text">
                        <i class="pi pi-cog font-size-icon" /> 
                        <div style="position: relative; bottom: 5px; left: 10px;">{{ $t('AppDashboardMapOverlay.Em manutenção') }}</div>
                    </div>
                    <div class="quantity-font-size">{{ displayFleetValue(maintenance_machines && maintenance_machines.length) }}</div>
                </div>

                <div class="scroll-box">
                    <div style="display: flex; flex-wrap: wrap; gap: 10px">
                        <div v-for="item in maintenance_machines" class="item-box" 
                                style="background-color: rgba(148, 0, 255, 0.4); border: 1px solid #9810FA; flex: 0 0 calc(50% - 10px); box-sizing: border-box;">
                            <div>{{ item.fleet }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            map_overlay_data: {
                type: Object
            },
            alerts: {
                type: Array,
                default: () => []
            },
            fleet_status: {
                type: Object
            },
            idle_machines: {
                type: Array,
                default: () => []
            },
            fuel_level: {
                type: Array,
                default: () => []
            },
            maintenance_machines: {
                type: Array,
                default: () => []
            }
        },
        mounted() {
            let scrollBoxes = document.querySelectorAll('.scroll-box');

            scrollBoxes.forEach(scrollBox => {
                scrollBox.addEventListener('wheel', (e) => {
                    e.preventDefault();
                    scrollBox.scrollBy({
                        top: e.deltaY < 0 ? -30 : 30,
                        behavior: 'smooth'
                    });
                }, { passive: false });
            });
        },
        methods: {
            displayValue(value, suffix = '') {
                return value != null ? this.formatValue(value) + suffix : '-'
            },
            displayValueHour(value, suffix = '') {
                if (value == null || isNaN(value)){
                    return '-'
                }

                let hours = Math.floor(value)
                let minutes = Math.round((value - hours) * 60)
                let finalHours = hours

                if (minutes === 60) {
                    finalHours++
                    minutes = 0
                }

                let hh = String(finalHours).padStart(2, '0')
                let mm = String(minutes).padStart(2, '0')

                return `${hh}${suffix}${mm}`
            },
            displayFleetValue(value) {
                return value != null ? value : '-';
            },
            formatValue(valor, min = 2, max = 2) {
                if(valor === 0){
                    return 0;
                }

                if (typeof valor === "string" && valor.trim() !== "" && !isNaN(valor)) {
                    valor = Number(valor);
                }

                if (typeof valor !== "number" || isNaN(valor) || !isFinite(valor)) {
                    return 0;
                }

                if (Number.isInteger(valor)) {
                    return new Intl.NumberFormat("pt-BR").format(valor);
                }

                return new Intl.NumberFormat("pt-BR", {
                    minimumFractionDigits: min,
                    maximumFractionDigits: max
                }).format(valor);
            },
            isValidUtilization(utilization, mechanical_availability){
                return utilization === '0%' && mechanical_availability === '0%' ? 'N/D' : utilization
            },
            isValidMechanicalAvailability(utilization, mechanical_availability){
                return utilization === '0%' && mechanical_availability === '0%' ? 'N/D' : mechanical_availability
            }
        }
    }
</script>

<style>

.item-body {
    pointer-events: auto; 
    width: 300px;
    height: auto; 
    padding: 15px; 
    background-color: rgba(0, 0, 0, 0.7); 
    border-radius: 8px; 
    color: white;
}

.item-text {
    font-size: 17px; 
    font-weight: bold; 
    margin-bottom: 5px; 
    display: inline-flex;
}

.item-box {
    width: 100%; 
    border-radius: 5px; 
    padding: 6px 10px;
    font-weight: bold; 
    font-size: 14px; 
    display: flex;                         
    justify-content: space-between;
}

.font-size-icon {
    font-size: 14px !important;
    position: relative;
    top: 1px;
}

.quantity-font-size {
    font-size: 16px; 
    font-weight: bold; 
    position: relative; 
    bottom: 4px;
}

.scroll-box {
    max-height: 80px;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: white rgba(0, 0, 0, 0);
}

.apply-height-item {
    height: 48px !important;
}

</style>